module.exports = __webpack_public_path__ + "img/squarelogo.2569a28c.png";